module.exports = __webpack_public_path__ + "static/media/mineman.4c5f06a9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/app/assets/mineman.png
 ** module id = 553
 ** module chunks = 0
 **/